import React from "react";
import Layout from "../../components/Layout";
import {
  Banner,
  D3For,
  StakeWithD3,
  ProtocolStats,
  Tokenomics,
  Roadmap,
  Articles,
  Community,
  Team,
  Faq,
} from "./sections";
const Home = () => {
  return (
    <div>
      <Layout>
        <Banner />
        <D3For />
        <StakeWithD3 />
        <ProtocolStats />
        <Tokenomics />
        <Roadmap />
        <Articles />
        <Community />
        <Team />
        <Faq />
      </Layout>
    </div>
  );
};

export default Home;
